import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { getCalculator } from "@/lib/catalog";
import CalculatorRunner from "@/components/CalculatorRunner";
import CalcErrorBoundary from "@/components/CalcErrorBoundary";

// Dev/QA helper: appending `?demoError=1` to any /calculator/:calcId URL
// renders a throwing child instead of the real runner so the error
// boundary's fallback card can be inspected visually. Production builds
// keep the boundary's contract intact; this query param is purely diagnostic.
function ThrowOnRender() {
  throw new Error("Demo runtime error — RigSentinel CalcErrorBoundary preview.");
}

export default function CalculatorDetail() {
  const { calcId } = useParams();
  const { search } = useLocation();
  const demoError = new URLSearchParams(search).get("demoError") === "1";
  const calc = getCalculator(calcId);
  // Key the boundary by calcId so navigating to a new calculator clears any
  // prior error state automatically (React unmounts on key change).
  if (!calc) {
    return (
      <div className="card-rs p-4 text-sm text-[var(--rs-text-2)]" data-testid="calc-not-found">
        Calculator not found.
      </div>
    );
  }
  return (
    <CalcErrorBoundary key={`${calcId}:${demoError ? "demo" : "live"}`}
                       calcLabel={calc.label || calc.name || calcId}>
      {demoError ? <ThrowOnRender /> : <CalculatorRunner calc={calc} />}
    </CalcErrorBoundary>
  );
}
